module.exports = __webpack_public_path__ + "static/media/findmotors.dc2ad1b9.png";